import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Xmlfields } from '../../../../../../../core/entities/xmlfields.model';
import { Fieldtypes } from '../../../../../../../core/entities/fieldtypes.model';
import { Fieldlinks } from '../../../../../../../core/entities/fieldlinks.model';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';
import { XmlfieldsService } from '../../../../../../../core/repositories/xmlfields.service';
import { FieldlinksService } from '../../../../../../../core/repositories/fieldlinks.service'
import { SelectItem } from 'primeng/api';

@Injectable()
export class EditDialogsXmlfieldsService {

  xmlfields: Xmlfields = new Xmlfields();
  originalXmlfields: Xmlfields = new Xmlfields();

  optionsFieldTypes: SelectItem[] = [];
  optionsFieldTypeBase: SelectItem[] = [];

  allXmlfields: Xmlfields[] = [];
  changetitulo: boolean = false;
  idxmldefs: number = 0;

  fieldtypes: Fieldtypes[] = new Array<Fieldtypes>();

  fieldlinks: Fieldlinks[] = new Array<Fieldlinks>();
  fieldlinksCheck: Fieldlinks[] = new Array<Fieldlinks>();

  typeSelectionFl: any[] = [{name: String, value:Boolean}];

  constructor(private xmlfieldsService: XmlfieldsService,
              private fieldlinksService: FieldlinksService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.xmlfields = data.xmlfield;
    this.changetitulo = data.titulochange;
    this.idxmldefs = data.dataId;
    this.originalXmlfields = _.cloneDeep(this.xmlfields);
    console.log(data);
    return forkJoin({
        valor0: this.xmlfieldsService.findAll(),
        valor1: this.internalHomeService.allFieldtypes(),
        valor2: this.internalHomeService.allFieldlinks()
    }).pipe(map(dataGroup => {

      this.allXmlfields = dataGroup.valor0 as Xmlfields[];
      this.fieldtypes = dataGroup.valor1;
      this.fieldlinks = dataGroup.valor2;

      this.optionsFieldTypeBase.push({value: null, label: ""});

      for(let i = 0; i < this.fieldtypes.length; i++){
        this.optionsFieldTypeBase.push({value: this.fieldtypes[i].code, label: this.fieldtypes[i].code});
      }

      if (Utils.noUndfAndNull(data.xmlfield)) {
        this.xmlfields = _.cloneDeep(data.xmlfield);
      }

      /*gestión de los checkbox de fieldlinks*/
      if(this.fieldlinks.length > 0){
        for(let i = 0; i < this.fieldlinks.length; i++){

          this.typeSelectionFl.push({name: this.fieldlinks[i].code, value: false});

          if (this.fieldlinks[i].xmlfields.length > 0) {
            for (let j = 0; j < this.fieldlinks[i].xmlfields.length; j++) {
              if (this.fieldlinks[i].xmlfields[j].code === this.xmlfields.code && data.idCodeCamp === this.fieldlinks[i].xmlfields[j].xmldefId) {
                this.typeSelectionFl[i].value = true;
              }
            }
          }
        }
      }else{
        for(let i = 0; i < this.fieldlinks.length; i++){
          this.typeSelectionFl.push({name: this.fieldlinks[i].code, value: false});
        }
      }

      console.log(this.typeSelectionFl);

      this.optionsFieldTypes = this.optionsFieldTypeBase;
      this.optionsFieldTypeBase = [];

      return true;
    }));
  }


  /**
  * @description
  * Guarda el Xmlfield
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.xmlfields.id, "")) {

      this.gestionCheckBox();
      /*comparamos el xmlfield original con el modificado*/
      let compareXmlfield = this.compare(this.xmlfields, this.originalXmlfields);

      if(compareXmlfield){
        return of(-1);
      }else{
        for(let i = 0; i < this.fieldtypes.length; i++){
          if(this.xmlfields.fieldtypeId.code === this.fieldtypes[i].code){
            this.xmlfields.fieldtypeId.id = this.fieldtypes[i].id;
          }
        }
        return this.xmlfieldsService.postXmlfield(this.xmlfields);
      }

    }else{
      this.gestionCheckBox();
      for(let i = 0; i < this.fieldtypes.length; i++){
        if(this.xmlfields.fieldtypeId.code === this.fieldtypes[i].code){
          this.xmlfields.fieldtypeId.id = this.fieldtypes[i].id;
          this.xmlfields.xmldefId = this.idxmldefs;
        }
      }
      return this.xmlfieldsService.postXmlfield(this.xmlfields);
    }
  }

  /**
  * @description
  * Adecuamos los chekbox seleccionados con los fieldlinks que corresponden
  */
  private gestionCheckBox() {
    let insertXmlField = new Xmlfields();
    this.fieldlinksCheck = _.cloneDeep(this.fieldlinks);
    console.log(this.typeSelectionFl);
    console.log(this.fieldlinks);
    for(let i = 0; i < this.typeSelectionFl.length; i++){
      for(let j = 0; j < this.fieldlinksCheck.length; j++){
        if(!this.typeSelectionFl[i].value && this.fieldlinksCheck[j] != null){
          if(this.typeSelectionFl[i].name === this.fieldlinksCheck[j].code){
             this.fieldlinksCheck.splice(j, 1);
            j--;
          }
        }
      }
    }

    for(let i = 0; i < this.fieldlinksCheck.length; i++){
      if(this.fieldlinksCheck[i] != null){
        insertXmlField.id = this.xmlfields.id;
        this.fieldlinksCheck[i].xmlfields.push(insertXmlField);
        this.fieldlinksService.postFieldlink(this.fieldlinksCheck[i]).subscribe((result:any) => {
          console.log(result);
        });
      }
    }
  }

  /**
  * @description
  * Comprueba si dos Xmlfields son iguales.
  * @param datoX Xmlfield 1
  * @param datoY Xmlfield 2
  * @returns True si son iguales
  */
  public compare(itemX:Xmlfields, itemY:Xmlfields):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.fieldtypeId.code !== null) {
        let value = itemX.fieldtypeId.code.toString();
        if (value === 'null') {
          itemX.fieldtypeId.code = "";
        }
      }

      if((itemX.code !== "" && (Utils.noUndfAndNull(itemX.fieldtypeId.code) && itemX.fieldtypeId.code !== "")))
      return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.xmlfields = new Xmlfields();
    this.typeSelectionFl = [];
  }

}
